/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeGrid,
  BaSeGridItem,
  BaSeLoading,
  BaSeTheme
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { useUserController } from '../../../hooks/controllers/user-controller';
import { useModule } from '../../../hooks/module/module';
import { EMAIL_REGEX } from '../../../utils/validators/constants';
import { managerNewMainRoute } from '../../manager-new/routes';

import imageHero from '../../shared/assets/hero-urbano.png';
import imageUnctad from '../../shared/assets/logo-unctad.png';



import CommonButton from '../../shared/components/common-button/common-button';
import CommonInput from '../../shared/components/common-input/common-input';
import { Footer } from '../../shared/components/footer/footer';
import Header from '../../shared/components/header/header';
import {
  ContainerHome,
  Content,
  ContentAuth,
  ContentHero,
  ContentRow,
  ContentTitle,
  Description,
  GradientContainer,
  InfoText,
  LinkAqui,
  TextAccess,
  TextBlock,
  TextGroup,
  Title,
  WrapperLink
} from './manager-home-styled';

const cache = Sebrae.StorageUtil.inTemporaryStore();
const cacheKeySebrae = '@empretec:sebrae';

const authText = (
  loading,
  navigateTo,
  resendEmailValidateUser,
  sendEmailValidateUser,
  input,
  setInput,
  showInput,
  setShowInput,
  messageValid,
  setMessageValid,
  showFormEmail,
  // eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  const isValidEmail = (email) => {
    if (!email || email?.trim() === '') {
      setMessageValid('Campo obrigatório!');
      return false;
    }

    if (!EMAIL_REGEX.test(email)) {
      setMessageValid('E-mail inválido!');
      return false;
    }

    setMessageValid('');
    return true;
  };
  return (
    <InfoText maxWidth={320}>
      {loading ? (
        <BaSeLoading />
      ) : (
        showFormEmail && (
          <TextGroup>
            {showInput ? (
              <BaSeGrid>
                <BaSeGridItem>
                  <ContentAuth>
                    <ContentTitle>
                      <Title>
                        Empreenda o que há
                        <br />
                        de melhor em você
                      </Title>
                      <img src={imageUnctad} alt="imageUnctad" />
                    </ContentTitle>
                  </ContentAuth>
                </BaSeGridItem>
                <BaSeGridItem >
                  <Description>
                    Caro usuário,
                  </Description>
                </BaSeGridItem>
                <BaSeGridItem >
                  <Description>
                    Caso você seja um gestor do Sebrae, por favor informe o seu
                    e-mail interno para validação do seu usuário e liberação de
                    acesso.
                  </Description>
                </BaSeGridItem>
                <BaSeGridItem size={12}>
                  <CommonInput
                    label=""
                    placeholder="Informe um e-mail Sebrae"
                    disabled={!showInput}
                    value={input}
                    onChange={(e) => {
                      const value = e.target.value;
                      setInput(value)
                    }}
                    name="email"
                  />
                </BaSeGridItem>
                <BaSeGridItem size={12}>
                  <CommonButton
                    disabled={!showInput}
                    variant="primary"
                    isBold={true}
                    backgroundColor="#0000C7"
                    onClick={() => {
                      if (isValidEmail(input)) {
                        sendEmailValidateUser(input).then(() => {
                          setShowInput(false);
                        });
                      }
                    }}
                  >
                    ENVIAR
                  </CommonButton>
                </BaSeGridItem>

                <BaSeGridItem>
                  <Description>
                    Caso seja um candidato do Empretec, sua entrevista pode ser
                    acessada pelo link:
                  </Description>
                </BaSeGridItem>


                <BaSeGridItem>

                  <LinkAqui
                    color={BaSeTheme.colors.gestao.azulAqua44}
                    onClick={() => navigateTo('/candidato')}
                  >
                    https://empretec.sebrae.com.br/candidato
                  </LinkAqui>
                </BaSeGridItem>
              </BaSeGrid>
            ) : (
              <React.Fragment>
                <div>
                  <Description>
                    Atenção Gestor, foi enviado um e-mail para você com um link
                    de acesso.
                  </Description>
                  <Description>
                    Por favor, acesse sua caixa de mensagem para confirmar sua
                    autenticação.
                  </Description>
                </div>
                <WrapperLink>
                  <Description>
                    Caso não tenha recebido o e-mail,
                  </Description>
                  <LinkAqui
                    color={BaSeTheme.colors.gestao.azulAqua44}
                    onClick={() => {
                      resendEmailValidateUser();
                    }}
                  >
                    clique aqui.
                  </LinkAqui>
                </WrapperLink>
              </React.Fragment>
            )}
          </TextGroup>
        )
      )}
    </InfoText>
  );
};

const unAuthText = (login) => {
  return (
    <BaSeGrid>
      <BaSeGridItem>
        <ContentAuth>
          <ContentTitle>
            <Title>
              Empreenda o que há
              <br />
              de melhor em você
            </Title>
            <img src={imageUnctad} alt="imageUnctad" />
          </ContentTitle>
        </ContentAuth>
      </BaSeGridItem>
      <BaSeGridItem>
        <CommonButton
          variant="primary"
          isBold={true}
          backgroundColor="#0000C7"
          onClick={() => login()}
        >
          Acessar o Sistema de Gestão
        </CommonButton>

      </BaSeGridItem>
      <BaSeGridItem>

        <TextAccess>
          <Description>
            Por aqui você tem acesso ao sistema de inscrições online. Com esse
            sistema você poderá cadastrar novos candidatos ao Empretec, enviar
            e-mail com o link para inscrição e também visualizar os resultados
            das entrevistas realizadas.
          </Description>
        </TextAccess>
        <Description>
          Seu papel é muito importante nesse processo.
        </Description>
      </BaSeGridItem>
    </BaSeGrid>
  );
};

export const ManagerHome = () => {
  const { isAuthenticated, login } = Sebrae.useAuth();
  const { navigateTo, getRouteParam } = Sebrae.useSebraeRouter();
  const { removeCache } = useModule();
  const {
    loading,
    checkUser,
    grantAccess,
    resendEmailValidateUser,
    sendEmailValidateUser,
  } = useUserController();

  const [input, setInput] = React.useState('');
  const [showInput, setShowInput] = React.useState();
  const [showFormEmail, setShowFormEmail] = React.useState();
  const [token] = React.useState(getRouteParam('token'));
  const [messageValid, setMessageValid] = React.useState();


  const check = React.useCallback(() => {
    checkUser().then((data) => {
      if (!data?.showFormEmail) {
        return navigateTo(managerNewMainRoute);
      }

      setShowInput(data?.showInputEmail);
      setShowFormEmail(data?.showFormEmail);
    });
  }, [checkUser, navigateTo]);

  const handleGrantAccess = React.useCallback(
    (cpf) => {
      grantAccess(cpf).then((response) => {
        return navigateTo(managerNewMainRoute, { forceReload: true });
      });
    },
    [grantAccess, navigateTo],
  );

  React.useEffect(() => {
    if (!isAuthenticated) {
      removeCache();
      cache.removeItem(cacheKeySebrae);
      return;
    }

    if (token) {
      handleGrantAccess(token);
      return;
    }

    check();


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, token]);

  return (
    <ContainerHome>
      <Header />

      <GradientContainer
        primary={'#215DF4'}
        secondary={'#699FFF'}
        tertiary={'#C5EAFF'}
        style={{ flex: 1 }}
      >
        <Content>
          <ContentRow>
            <TextBlock>
              {isAuthenticated
                ? authText(
                  loading,
                  navigateTo,
                  resendEmailValidateUser,
                  sendEmailValidateUser,
                  input,
                  setInput,
                  showInput,
                  setShowInput,
                  messageValid,
                  setMessageValid,
                  showFormEmail,
                )
                : unAuthText(login)}
            </TextBlock>
            <ContentHero>
              <img src={imageHero} alt="hero" />
            </ContentHero>
          </ContentRow>
        </Content>
      </GradientContainer>
      <Footer />
    </ContainerHome>
  );
};
